var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.surveySchema)?_c('SurveyForm',{attrs:{"schema":_vm.surveySchema,"template-id":_vm.templateId,"allow-save":_vm.allowSave}}):_c('p',[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }